<app-header-navigation-bar></app-header-navigation-bar>

<div class="notifications-page">

    <app-page-header title="Notificaciones" subtitle="Revisa las notificaciones de tus seguros contratados" [accent]="true"></app-page-header>

    <main class="notifications-main">

        <div class="notifications-card">

            <header class="card-header">
                <span class="card-header-icon" aria-hidden="true">
                    <img src="resources/assets/images/notifications/notifications-icon.svg" alt="">
                </span>
                <h2 class="card-header-title">Notificaciones</h2>
            </header>

            <div class="notifications-list" *ngIf="notifications && notifications.length > 0">
                <article class="notification-item" *ngFor="let item of notifications"
                         [class.notification-item--unread]="item.isRead !== 'S'">

                    <img class="notification-dot" aria-hidden="true" alt=""
                         [src]="item.isRead === 'S'
                                ? 'resources/assets/images/notifications/blue-dot-icon.svg'
                                : 'resources/assets/images/notifications/green-dot-icon.svg'"
                         (click)="markAsRead(item)">

                    <div class="notification-body" (click)="markAsRead(item)">
                        <div class="notification-row">
                            <h3 class="notification-title">{{ item.title }}</h3>
                            <span class="notification-date">{{ item.creationDate }}</span>
                        </div>

                        <p class="notification-annotation" [innerHTML]="item.annotation"></p>

                        <a class="notification-link" *ngIf="item.expediente"
                           [href]="item.expediente.href" (click)="$event.stopPropagation()">
                            <img src="resources/assets/images/notifications/link-icon.svg"
                                 alt="" aria-hidden="true">
                            <span>Ver expediente {{ item.expediente.ref }}</span>
                        </a>
                    </div>

                    <button type="button" class="notification-delete"
                            (click)="delete(item)"
                            aria-label="Eliminar notificación">
                        <img src="resources/assets/images/notifications/delete-notification-icon.svg"
                             alt="" aria-hidden="true">
                    </button>
                </article>
            </div>

            <div class="notifications-empty"
                 *ngIf="!loading && (!notifications || notifications.length === 0)">
                <p>No tienes notificaciones pendientes de leer</p>
            </div>

            <div class="notifications-loading" *ngIf="loading">
                <p>Cargando<span>.</span><span>.</span><span>.</span></p>
            </div>

        </div>

        <div class="notifications-actions"
             *ngIf="notifications && notifications.length > 0">
            <button type="button" class="notif-btn notif-btn--accent"
                    (click)="deleteAll()" [disabled]="readingNotifications">
                Eliminar todo
            </button>
            <button type="button" class="notif-btn notif-btn--primary"
                    (click)="readAll()" [disabled]="readingNotifications">
                Leer todo
            </button>
        </div>

    </main>

</div>

<app-footer></app-footer>
